module.exports = __webpack_public_path__ + "img/10_life-skills.5c3f3569.png";